import { Link } from 'react-router-dom';
import { LanguageSelector } from '@/shared/ui';

export function Header() {
  return (
    <header className="flex w-full justify-between items-center shrink-0 border-b border-border bg-background px-6 py-4">
      <div className="flex items-center gap-2">
        <Link to="/">
          <img src="/logos/black/rita-logo.svg" alt="RITA" className="h-10 w-auto" />
        </Link>
      </div>

      <div className="flex items-center">
        <LanguageSelector />
      </div>
    </header>
  );
}
